import Timepoint from '../../../../../foundation/time/Timepoint';

export default class WaitingTimeCalculator {

	private static instance: WaitingTimeCalculator;

	private constructor () {}

	public static getInstance () {
		return this.instance !== undefined ? this.instance : this.instance = new this();
	}

	public execute (timepoint: Timepoint) {
		const microseconds = timepoint.getMicrotimestamp() - Timepoint.now().getMicrotimestamp();

		if (microseconds <= 2000) {
			return microseconds + ' microseconds';
		}

		const milliseconds = Math.round(microseconds / 1000);

		if (milliseconds <= 2000) {
			return milliseconds + ' milliseconds';
		}

		const seconds = Math.round(milliseconds / 1000);

		if (seconds <= 120) {
			return seconds + ' seconds';
		}

		const minutes = Math.round(seconds / 60);

		if (minutes <= 120) {
			return minutes + ' minutes';
		}

		const hours = Math.round(minutes / 60);

		if (hours <= 48) {
			return hours + ' hours';
		}

		const days = Math.round(hours / 24);

		if (days <= 14) {
			return days + ' days';
		}

		const weeks = Math.round(days / 7);

		return weeks + ' weeks';
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/lessons/domain/services/WaitingTimeCalculator.ts